import { useState, type FormEvent } from "react";
import { Modal } from "../../components/Modal.tsx";
import { api } from "../../api.ts";

export function ChangePassword() {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [success, setSuccess] = useState(false);
  const [busy, setBusy] = useState(false);

  function changeOpen(value: boolean) {
    if (busy) return;
    setOpen(value);
    if (!value) {
      setMessage("");
      setSuccess(false);
    }
  }

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const form = event.currentTarget;
    const fields = new FormData(form);
    const currentPassword = String(fields.get("currentPassword") ?? "");
    const newPassword = String(fields.get("newPassword") ?? "");
    const confirmPassword = String(fields.get("confirmPassword") ?? "");

    setMessage("");
    setSuccess(false);

    if (newPassword.length < 12) {
      setMessage("A nova senha deve ter no mínimo 12 caracteres.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setMessage("A confirmação da nova senha não coincide.");
      return;
    }

    if (currentPassword === newPassword) {
      setMessage("A nova senha deve ser diferente da senha atual.");
      return;
    }

    setBusy(true);
    try {
      await api("/api/auth/change-password", {
        currentPassword,
        newPassword,
        revokeOtherSessions: true,
      });
      form.reset();
      setSuccess(true);
      setMessage("Senha alterada com sucesso! Guarde-a em local seguro.");
    } catch (error) {
      setMessage(
        error instanceof Error
          ? error.message
          : "Não foi possível alterar a senha. Confira a senha atual.",
      );
    } finally {
      setBusy(false);
    }
  }

  return (
    <>
      <button className="button secondary" onClick={() => changeOpen(true)}>
        Alterar senha
      </button>
      <Modal
        open={open}
        onOpenChange={changeOpen}
        title="Alterar senha de acesso"
        description="Defina sua nova senha definitiva. Ela deve ter pelo menos 12 caracteres."
      >
        <form onSubmit={submit} className="form">
          {message && (
            <p
              role="status"
              className={success ? "feedback-positive" : "form-error"}
              style={success ? { color: "var(--color-primary, #059669)", fontWeight: 500 } : undefined}
            >
              {message}
            </p>
          )}

          {!success && (
            <>
              <div className="field">
                <label htmlFor="change-current-password">Senha atual (ou provisória)</label>
                <input
                  id="change-current-password"
                  name="currentPassword"
                  type="password"
                  autoComplete="current-password"
                  required
                  disabled={busy}
                />
              </div>

              <div className="field">
                <label htmlFor="change-new-password">Nova senha (mínimo 12 caracteres)</label>
                <input
                  id="change-new-password"
                  name="newPassword"
                  type="password"
                  autoComplete="new-password"
                  required
                  minLength={12}
                  disabled={busy}
                />
              </div>

              <div className="field">
                <label htmlFor="change-confirm-password">Confirmar nova senha</label>
                <input
                  id="change-confirm-password"
                  name="confirmPassword"
                  type="password"
                  autoComplete="new-password"
                  required
                  minLength={12}
                  disabled={busy}
                />
              </div>

              <div className="dialog-actions">
                <button
                  type="button"
                  className="button secondary"
                  onClick={() => changeOpen(false)}
                  disabled={busy}
                >
                  Cancelar
                </button>
                <button type="submit" className="button" disabled={busy}>
                  {busy ? "Salvando..." : "Salvar nova senha"}
                </button>
              </div>
            </>
          )}

          {success && (
            <div className="dialog-actions">
              <button
                type="button"
                className="button"
                onClick={() => changeOpen(false)}
              >
                Concluir
              </button>
            </div>
          )}
        </form>
      </Modal>
    </>
  );
}
